const ADD_SCHEDULE = '[schedules]add.schedule'
const CLEAR_SCHEDULES = '[schedules]clear.schedules'
const CLEAR_SCHEDULES_EXCEPT = '[schedules]clear.schedules.except.one'

export {
	ADD_SCHEDULE, 
	CLEAR_SCHEDULES,
	CLEAR_SCHEDULES_EXCEPT
}